import { mdiDomain, mdiAccountPlusOutline } from '@mdi/js'
import { PRIVATE } from '@/plugins/acl/const'

export default [
  {
    subheader: 'sale',
    resource: PRIVATE.SALE.MENU_HEADER,
    action: 'read',
  },
  {
    title: 'clients',
    icon: mdiDomain,
    to: 'sale-client-list',
    resource: PRIVATE.STAFF.CLIENTS,
    action: 'read',
  },
  {
    title: 'leads',
    icon: mdiAccountPlusOutline,
    to: 'sale-leads',
    resource: PRIVATE.SALE.LEADS,
    action: 'read',
  },
]
